<template>
	<div class="i-wysiwyg">
		<btn @press="edit" :l='label' i='pencil' size='medium'/>
		<modal title='edit content' name="wyiwyg-editor" :widescreen="true" onClose="onClose">
			<iframe border="0" ref="frame" class='editor-frame' id='editor-frame' :src="frame_src"></iframe>
		</modal>
	</div>
</template>

<script>
export default {
  name: 'i-wysiwyg',
  props:{
  	value:String,
  	label:String
  },

  mounted(){
  },
  methods:{
    onClose(){
      console.log('CLOSED')
      window.removeEventListener('message',this.onMessage);
    },
    onMessage(e){
      let self = this;
      console.log(e,this.uuid);
      if(e.data.mode === 'saveWysiwygHtml' && e.data.uuid === self.uuid){
        console.log("AAAA1", e.data.html);
      }
    },
  	edit(){
  		let self = this;
  		this.$store.commit('modalOpen', 'wyiwyg-editor');
      //window.addEventListener('message',this.onMessage);

  		this.frame_src = '/libs/wysiwyg/';
  		//frame.appendTo();
      setTimeout(()=>{
        //console.log(document.getElementById('editor-frame'))
        let frame = _i.frameApi(document.getElementById('editor-frame'));
        frame.on('iLoaded',(e)=>{
          frame.send({mode:'loadHtml',value:self.value || ''},(data)=>{
              console.log(data);
          });
        });
        frame.on('saveWysiwygHtml',(data)=>{
          self.$store.commit('modalClose', 'wyiwyg-editor');
          self.$emit('input',data.html.replace(/ +/gim," ").replace(/\n/gim,""));
          self.$forceUpdate();
        });
        frame.send({mode:'initUid'},(data)=>{
            console.log(data);
        });

      },800);
      
      
      

	  	console.log("WYSILOAD");

	  	//window.onmessage = ;


  	}
  },
  data () {
  	
    return {
    	opened:false,
    	frame_src:'',
    	buffer:""
    }
  }
}
</script>

<style lang="css" scoped>
.editor-frame{
	width:100%;
	height:100%;
	border:none;
}
</style>